module.exports = __webpack_public_path__ + "img/pdf-top.2deae535.png";